import api from "./invoke";
import {
  BEST_PRICES,
  COINS_MARKETS,
  CONTACTUS,
  LOGIN,
  TOKENS,
  USER_PROFILE,
  WITHDRAW_FEE,
  DAILY_HISTORY,
} from "constants/endpoints";

// Get bets price
export const getBestPrices = async () => {
  return await api.get(BEST_PRICES);
};
//Get Tokens
export const getTokens = async () => {
  return await api.get(TOKENS);
};

// Login with email and password
export const login = async (email: string = "", password: string = "") => {
  const data = await api.post(LOGIN, { email, password });
  return data;
};

// Get user info
export const userInfo = async () => {
  return await api.get(USER_PROFILE);
};

export const getDayHistoryChart = async (symbol: any) => {
  return await api.get(DAILY_HISTORY(symbol));
};

//Get coins markets
export const coinsMarkets = async (coinName: string) =>
  await api.get(COINS_MARKETS(coinName));

//post contact value
export const contactUs = async (payloads: any) => {
  const data = await api.post(CONTACTUS, {
    ...payloads,
  });
  return data;
};

export const getWithdrawFee = async () => {
  return await api.get(WITHDRAW_FEE);
};
